<template lang='pug'>
  .container
    .container
      .row.mt-5.align-items-center
        .col-12.my-header.font-weight-bold
            | Настройки опроса

    .container(v-if="loading")
      .loader_holder
        object(type="image/svg+xml" data="/assets/loaders/infinity.svg")

    .container.white_block.settings.mt-5(v-if="!loading")
      .row
        .col-12
          h3 Конструктор формы  
      .row.inputModule
        input-module(type="checkbox" title="Включить форму" v-model="settings.working" label="Включить")
      .row.inputModule
        input-module(type="image" title="Логотип" v-model="settings.logo" about="Лучше всего выбрать изображение размером 200x100px.")
      .row.inputModule
        input-module(type="text" title="Заголовок приветствия" v-model="settings.welcome_header" emojis="true")
      .row.inputModule
        input-module(type="text" title="Текст приветствия" v-model="settings.welcome_text" emojis="true")
      .row.inputModule
        input-module(type="text" title="Кнопка для старта" v-model="settings.welcome_button" emojis="true")
      .row.inputModule
        input-module(type="smsfeedback-questions" title="Вопросы формы" v-model="settings.questions")
      .row.inputModule
        input-module(type="text" title="Заголовок благодарности за прохождение опроса" v-model="settings.thx_header" emojis="true")
      .row.inputModule
        input-module(type="text" title="Текст благодарности за прохождение опроса" v-model="settings.thx_text" emojis="true")
      .row.inputModule
        input-module(type="number" title="Через какой промежуток дней отправить сообщение снова после посещения?" v-model="settings.days_between" about="Например, 30. Гость приходит каждый день, но сообщение он будет получать только через каждые 30 дней.")
      .row.inputModule
        input-module(type="code-css" title="Дополнительный CSS код" v-model="settings.styles")
      .row
        br
        button.save_form.styled(v-on:click="saveSettingns()") Сохранить
        a.show_form(:href="preview_link" target="_blank") Посмотреть как выглядит опрос

    .container.mt-5.white_block(v-if="!loading")
      .row
        .col-12
          h3 Настройки СМС
      .row.inputModule
        input-module(type="text" title="Текст СМС-сообщения" v-model="sms_template.template" :placements="[{value: '%имя%', name: 'Имя гостя'},{value: '%ссылка%', name: 'Ссылка на опрос'}]" @change='checkSMS')
      .row.inputModule
        input-module(type="checkbox" title="Сокращать ссылку" :disabled="sl_enabled" label="Сократить через ShortLink" v-model="sms_template.sl" @change='checkSMS' :about='sl_enabled?"":"У Вас не подключен сервис ShortLink."')
        .example Пример сообщения: 
          .sms {{sms_temp_example}}
        .toolong(v-if="toolong") Сообщение получится слишком большим. Используйте сообщения до 75 символов.
      .row
        button.styled(v-on:click="saveTemplate()" :disabled='toolong') Сохранить

</template>
<script>
var apiDriver = require("../../apiDriver").default;
// import InputModule from '../../Components/InputModule';

export default {
  data() {
    return {
      settings: {},
      sms_template: {
        sl: 0,
        template: ''
      },
      sl_enabled: 0,
      loading: true,
      preview_link: '',
      toolong: false,
      sms_temp_example: ''
    };
  },

  computed: {},

  mounted() {
    let subscriptions = this.$store.state.userData.subscriptions;
    let sl = subscriptions.find(x=>x.service_id==8);
		if(sl) this.sl_enabled = 1;
    this.loadSettings();
  },

  methods: {
    async loadSettings(){
      let settings = (await apiDriver.services.api.get('sms_feedback', "settings")).data;
      let sms_template = (await apiDriver.services.api.get('sms_feedback', "SMSTemplate")).data;
      // settings.settings.questions = JSON.stringify(settings.settings.questions);
      this.settings = settings.settings;
      this.sms_template = sms_template.sms_template;
      if(!this.sl_enabled) this.sms_template.sl = 0;
      this.preview_link = 'http://feedback.actid.ru/?preview='+settings.settings.id+"-"+settings.settings.user_id;
      console.log("settings:", settings)
      console.log("sms_template:", sms_template);
      this.checkSMS();
      this.loading = false;
    },
    async saveSettingns(){
      // this.$notify({type: 'success', title: 'Уведомление', text: 'Настройки успешно сохранены!', group:'notifications'});
      this.$toast.success('Настройки успешно сохранены!')
      let settings = await apiDriver.services.api.post('sms_feedback', "settings", this.settings);
      if(!settings.done) alert("Произошла ошибка сохранения настроек")
    },
    async saveTemplate(){
      // this.$toast.open({type: 'success', message: 'СМС-шаблон успешно сохранен!'});
      this.$toast.success('СМС-шаблон успешно сохранен!')
      // this.$notify({type: 'success', title: 'Уведомление', text: 'СМС-Шаблон успешно сохранен!', group:'notifications'});
      let template = await apiDriver.services.api.post('sms_feedback', "SMSTemplate", this.sms_template);
      if(!template.done) alert("Произошла ошибка сохранения смс-шаблона")
    },
    checkSMS(){
      console.log('checkSMS', this.sms_template.template, this.sms_template.template.length);
      let link = this.sms_template.sl == 1?'sl.actid.ru/r/aAaAaAaAa':'feedback.actid.ru/?token=5paynxPkD4oXC8qhhZw7ff';
      if(this.sms_template.template){
        let x = this.sms_template.template.replace(/%имя%/g, 'Анастасия').replace(/%ссылка%/g, link);
        this.sms_temp_example = x;
        if(x.length >= 70){
          this.toolong = true;
        }else{
          this.toolong = false;
        }
      }
    }
  }
};
</script>
<style scoped lang="stylus">
.white_block {
  background: white;
  margin: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 7px;
}

.my-header {
  font-size: 26pt;
}

.header-sub {
  // color: white;
  font-size: 1.5rem;
}

button.styled, a.styled {
  margin-bottom: 5px;
  border: 1px solid #6c68cb;
  padding: 10px 15px;
  border-radius: 4px;
  color: #464384;
  cursor: pointer;
  background white;
  margin-left 10px;

  &:hover {
    background: #6c68cb;
    color: white;
  }

  &[disabled] {
    border-color: #ddd;
    color: #ddd;
    cursor: default;
    background: white;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.inputModule{
  margin-bottom 10px;
}

.show_form{
  color: #6c68cb;
  font-weight: 300;
  display: block;
  margin-left: auto;
  margin-right: 10px;
  position: relative;
  top: 12px;
}

.toolong{
  padding: 5px 10px;
  background: #f44336;
  border-radius: 4px;
  margin-left: 30px;
  margin-top: 10px;
  color: white;
}

.example{
    padding: 5px 10px;
    background: #4CAF50;
    border-radius: 15px;
    margin-left: 30px;
    margin-top: 10px;
    color: #ffffff94;
    cursor default;
    .sms{
      color: white;
    }
}

.settings{
  // padding-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .show_form{
    top: 0;
    left: 0;
    margin: 0;
    margin-top: 10px;
    text-align: center;
    display: block;
    width: 100%;
  }
  button.styled{
    width: 100%;
  }
  .example{
    margin-left: 10px;
  }
}

</style>
